import { useParams } from 'react-router';

export const useDistributionSlug = (): string => {
  const { distributionSlug } = useParams<{ distributionSlug?: string }>();
  if (!distributionSlug) {
    throw new Error('Unsupported route - params does not contain "distributionSlug"');
  }
  return distributionSlug;
};
